import React, { useState, useEffect } from "react";
import { connect, useDispatch } from 'react-redux';
import { rejectProformaLineAction, rejectProformaAction,  loadingToggleAction } from "../../../../store/actions/AccordPreaActions";
import { Button, Modal } from "react-bootstrap";
import Select from 'react-select';
import { useTranslation } from "react-i18next";

export const MotifRejetOpticModal = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { manageCommentModal, history, acte, total, exclusions, motifRejet, isDetail, montantAssureur, montantRejete } = props;
    const [error, setError] = useState(null);
    const [motif, setMotif] = useState(motifRejet || '');
    const [amountAvr, setAmountAvr] = useState(isDetail ? parseFloat(total) : parseFloat(montantAssureur) + parseFloat(montantRejete));
    const [amountApr, setAmountApr] = useState(isDetail ? 0 : parseFloat(montantAssureur));
    const [amount, setAmount] = useState(isDetail ? 0 : parseFloat(montantRejete));
    const [amountVal, setAmountVal] = useState(isDetail ? parseFloat(total) : parseFloat(montantAssureur));

    const addCommentRequest = () => {
        if(motif.trim().length === 0) {
            setError(t('common.motif-error'));
            return;
        }

        const data = {
            amount,
            motif,
            commentaire: ""
        };

        dispatch(loadingToggleAction());
        isDetail ? dispatch(rejectProformaLineAction(acte.acteId, data)) : dispatch(rejectProformaAction(acte.opticBon.code, data));
        manageCommentModal(data);

    }

    return (
            <>
                    <Modal.Header>
                        <Modal.Title className="text-center" >
                                {isDetail ? t('common.reject-on')+acte.acte : t('common.glasses-reject')}<br/>
                        </Modal.Title>
                        <Button
                            variant=""
                            className="close"
                            onClick={() => manageCommentModal(false)}
                        >
                            <span>&times;</span>
                        </Button>
                    </Modal.Header>
                    <Modal.Body>
                        <h5>{t('common.reject-intro')}</h5>
                        
                        { error && <small className="text-danger">{{error}}</small> }

                        <form onSubmit={(e) => e.preventDefault()}>
                            
                                <div className="row mb-2">
                                {isDetail && (
                                    <div className="col-5">
                                    <b><small>{t('common.before-reject-amount')}:{' '}</small></b>
                                    <b>{amountAvr.toFixed(2)}</b>
                                </div>)}
                                {isDetail && (
                                <div className="col-5">
                                    <b><small>{t('common.after-reject-amount')}:{' '}</small></b>
                                    <b>{amountApr.toFixed(2)}</b>
                                </div>
                                )}
                                {isDetail && (<div className="col-2">
                                    <Button
                                        variant="info light"
                                        onClick={() => {
                                            setAmount(amountAvr);
                                            setAmountApr(0);
                                        }}
                                    >
                                       {t('common.reject-all')}
                                    </Button>
                                </div>)}
                            </div>
                            {isDetail && (<div className='form-group'>
                                <label className='mb-1 '>
                                    <strong>{t('common.amount-rejected')}</strong>
                                </label>
                                <input
                                    type='number'
                                    name='amount'
                                    min='0'
                                    max={amountAvr}
                                    className='form-control'
                                    placeholder='0'
                                    value={amount}
                                    onChange={(e) => {
                                        setAmount(e.target.value);
                                        setAmountVal(amountAvr - e.target.value);
                                        setAmountApr(amountAvr - e.target.value);
                                    }}
                                />
                            </div>)}
                            {isDetail && (<div className='form-group'>
                                <label className='mb-1 '>
                                    <strong>{t('common.amount-validated')}</strong>
                                </label>
                                <input
                                    type='number'
                                    name='amountVal'
                                    min='0'
                                    max={amountAvr}
                                    className='form-control'
                                    placeholder='0'
                                    value={amountVal}
                                    onChange={(e) => {
                                        setAmountVal(e.target.value);
                                        setAmount(amountAvr - e.target.value);
                                        setAmountApr(e.target.value);
                                    }}
                                />
                            </div>)}
                            <div className='form-group'>
                                <label className='mb-1 '>
                                    <strong>{t('appointment.reason')}</strong>
                                </label>
                                <Select
                                    className="select-search"
                                    selected={exclusions.filter(exclu => {return exclu.nameFr === motif})[0]?.id}
                                    placeholder="Choisir un motif"
                                    required
                                    onChange={(val) => {setMotif(val.label)}}
                                    options={exclusions.map((opt)=>{return {label:opt.nameFr,value:opt.id}})}
                                    style={{
                                    lineHeight: '40px',
                                    color: '#7e7e7e',
                                    paddingLeft: ' 15px',
                                    }}
                                />
                            </div>
                        </form>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="danger light"
                            onClick={() => manageCommentModal(false, false)}
                        >
                           {t('common.cancel')}
                        </Button>
                        <Button
                            variant=""
                            type="button"
                            className="btn btn-primary"
                            disabled={motif.trim().length === 0}
                            onClick={() => addCommentRequest()}
                        >
                           {t('client.submit')}
                        </Button>
                    </Modal.Footer>
            </>
    )
};

const mapStateToProps = (state) => {
    return {
        drugList: state.consultation.drugs
    };
};

export default connect(mapStateToProps)(MotifRejetOpticModal);